import React, { useState, useEffect, useCallback, useContext } from 'react';
import { Redirect } from 'react-router';
import 'bootstrap/dist/css/bootstrap.css';
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridItem from "app/components/Grid/GridItem.js";
import GridContainer from "app/components/Grid/GridContainer.js";
import CustomInput from "app/components/CustomInput/CustomInput.js";
import Button from "app/components/CustomButtons/Button.js";
import Card from "app/components/Card/Card.js";
import CardBody from "app/components/Card/CardBody.js";
import CardFooter from "app/components/Card/CardFooter.js";
import axios from 'axios';
import Box from '@material-ui/core/Box';
import logo from "../../layout/logoweb.png";
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import CircularProgress from '@mui/material/CircularProgress';
import { LoginStatusContext } from 'app/context/LoginStatusContext';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useLocation } from 'react-router-dom';
const styles = {
    cardCategoryWhite: {
        color: "rgba(255,255,255,.62)",
        margin: "0",
        fontSize: "14px",
        marginTop: "0",
        marginBottom: "0",
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
    },
};

const useStyles = makeStyles(styles);

//React export function used to display the login page.
export default function Login() {

    //Setting the use states for the Signed In user and the Login Errors. 
    const [isLoginError, setIsLoginError] = useState("");
    const [forgottenPassword, setForgottenPassword] = useState(false);
    const [loggingIn, setLoggingIn] = useState(false);

    const { isLoggedIn, setIsLoggedIn, loginRefreshRequired, setLoginRefreshRequired } = useContext(LoginStatusContext);

    const [data, setData] = useState({ username: '', password: '', recaptchaToken: '' });

    if (loginRefreshRequired) {
        setLoginRefreshRequired(false);
        window.location.reload();
    }

    const { executeRecaptcha } = useGoogleReCaptcha();

    useEffect(() => {
        async function submitForm() {
            try {
                setLoggingIn(true);
                const url = `${process.env.REACT_APP_API_ENDPOINT}/api/login`;
                await axios.post(url, data).then((res) => {
                    setSessionData(res.data);
                    setIsLoggedIn(true);
                })
            } catch (error) {
                setData((prev) => ({ ...prev, password: '', recaptchaToken: '' }));
                setIsLoginError("User failed to login.");
            } finally {
                setLoggingIn(false);
            }
        }

        if (data.recaptchaToken) {
            submitForm();
        }
    }, [data, setIsLoggedIn])

    const handleSumitForm = useCallback(
        async (e) => {
            e.preventDefault();

            if (!executeRecaptcha) {
                console.log("Execute recaptcha not yet available");
                return;
            }

            try {
                const recaptchaToken = await executeRecaptcha("login");
                setData((prev) => ({ ...prev, recaptchaToken: recaptchaToken }));
            } catch (error) {
                console.error('An error occured whilst retrieving the reCaptcha token.');
            }
        }, [executeRecaptcha]);

    function forgottenPasswordMsg() {
        if (forgottenPassword === false) {
            setForgottenPassword(true);
        }
        else {
            setForgottenPassword(false);
        }
    }

    const setSessionData = (data) => {
        sessionStorage.setItem('_LogOutInMins', data.logOutInMins);
        sessionStorage.setItem('_GreetingMessage', `User: ${data.forename}`);
        sessionStorage.setItem('_UserSystemKey', data.userSystemKey);
        sessionStorage.setItem('_HomeCostCentreId', data.homeCostCentreId);
        sessionStorage.setItem('_UserId', data.userId);
        sessionStorage.setItem('_UserCountryCode', data.countryCode);
    }

    const classes = useStyles();

    //If the user is signed in redirect them to the homepage. 
    if (isLoggedIn === true) {
        return <Redirect to={{ pathname: "/LeoSeaPortal/dashboard" }} />;
    } else {
        return (
            <div>

                <form onSubmit={handleSumitForm}>
                    <Box m={20}>
                        <GridContainer className={classes.root} align="center" justifyContent="center">
                            <GridItem xs={12} md={6}>
                                <Card>
                                    <div className={classes.header} style={{ backgroundColor: "#FFF", minHeight: "100px" }}>
                                        <img src={logo} alt="logo" style={{ paddingTop: "25px" }} />
                                    </div>
                                    <><CardBody>
                                        <GridContainer>
                                            <GridItem xs={12}>
                                                <CustomInput
                                                    labelText="User Name"
                                                    id="username"
                                                    name="username"
                                                    type="text"
                                                    formControlProps={{
                                                        fullWidth: true,
                                                        required: true,
                                                    }}
                                                    inputProps={{
                                                        value: data.username,
                                                        onChange: (e) => setData({ ...data, username: e.target.value }),
                                                    }} />
                                            </GridItem>
                                        </GridContainer>
                                        <GridContainer>
                                            <GridItem xs={12}>
                                                <CustomInput
                                                    labelText="Password"
                                                    id="password"
                                                    name="password"
                                                    type="password"
                                                    autoComplete="off"
                                                    formControlProps={{
                                                        fullWidth: true,
                                                        required: true,
                                                    }}
                                                    inputProps={{
                                                        value: data.password,
                                                        onChange: (e) => setData({ ...data, password: e.target.value }),
                                                    }} />
                                            </GridItem>
                                        </GridContainer>
                                        <GridContainer>
                                            <GridItem>
                                                <div style={{ color: "red" }}>{isLoginError}</div>

                                            {forgottenPassword && (<Alert id="info" severity="info">
                                                <AlertTitle>To reset your password, please email
                                                    seaportalhelpdesk@europa-worldwide.com</AlertTitle>
                                            </Alert>)}

                                            </GridItem>
                                        </GridContainer>
                                    </CardBody>
                                        <CardFooter>
                                            <Button color="primary" disabled={loggingIn} data-testid="loginpagesubmit" type="submit">Login</Button>
                                            {loggingIn && (<CircularProgress style={{ position: 'absolute', marginLeft: 30, color: '#FFF' }}></CircularProgress>)}
                                            <Button color="blue" onClick={forgottenPasswordMsg}>Forgotten Password</Button>
                                        </CardFooter></>

                                </Card>
                            </GridItem>
                        </GridContainer>
                    </Box>
                </form>
            </div>
        );
    }
}